module.exports = __webpack_public_path__ + "static/media/blog5.ccf76b69.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blog5.webp
// module id = 282
// module chunks = 0